module.exports = __webpack_public_path__ + "static/media/coldWeather.4d3b242c.png";